import { AutoshipStatusType } from 'types/business-data/IAutoship';

export const AUTOSHIP_BADGE_BACKGROUND_COLORS: Record<
  AutoshipStatusType,
  string
> = {
  processed: '#ebf2ef',
  paused: '#fbdfc7',
  notProcessed: '#fdefc0',
  cancelled: '#f8d5d2'
};

export const AUTOSHIP_BADGE_CONTENT_COLORS: Record<AutoshipStatusType, string> =
  {
    processed: '#397f5c',
    paused: '#c9630d',
    notProcessed: '#ba8f04',
    cancelled: '#e03022'
  };
